import { useTranslation } from 'react-i18next'
import { Base } from '@itsrever/design-system'

// Takes a settings editor's place when its stored value did not load: an editor started empty
// would save over it.
export const LoadError: React.FC<{ message: string; onRetry: () => void }> = ({
  message,
  onRetry
}) => {
  const { t } = useTranslation()
  return (
    <Base.Callout className="flex items-center justify-between gap-4">
      <p className="text-sm">{message}</p>
      <Base.Button type="button" variant="secondary" onClick={onRetry}>
        {t('load_error.retry')}
      </Base.Button>
    </Base.Callout>
  )
}
